import { DomHelper } from "./domHelper";
import { getBackendData, sendBackendData } from "./xhrbackend";
import { getAppCardNode } from "./appCardDefault";
import { Util } from "./util";
import { DEBUG, DEFAULT_PREFS } from "./config";
let store;
export function appUserInvitation(globalStore, username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appUserInvitation");
    const additionalClassList = ['full-width-interaction'];
    store = globalStore;
    const idString = 'rudi-voucher';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const hastTOTPPermission = Util.userHasRole(userResponse, 'odapp_it_user_invitation_totp');
    const cardNode = getAppCardNode(parentNode, app, userResponse.username, userResponse.odDeskPreferences, bearerToken, false, [], null, (event) => {
        if (DEBUG)
            console.log("appUserInvitation");
        let injectNode = cardNode.querySelector(`.rudi-app-inject`);
        handleClickOpen(cardNode, injectNode, event, username, bearerToken, userResponse.odDeskPreferences, idString, userResponse.odSapidOE, hastTOTPPermission);
    });
}
function handleClickOpen(cardNode, injectNode, event, username, bearerToken, userPreferences, idString, sapidoe, hastTOTPPermission) {
    if (!injectNode) {
        injectNode = document.getElementById(idString);
    }
    else {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", idString);
    }
    if (cardNode.classList.contains("app-open")) {
        if (DEBUG)
            console.log("RespApp do nothing");
    }
    else {
        cardNode.classList.add('app-open');
        cardNode.classList.add('rudi-col-span-3');
        cardNode.classList.remove('rudi-max-height');
        const formNode = DomHelper.appendNode(injectNode, 'section', [], [], '', 'rudi-invitation-form');
        DomHelper.appendNode(injectNode, 'section', ['disabled'], [], '', 'rudi-invitation-error-message');
        const listNode = DomHelper.appendNode(injectNode, 'section', [], [], '', 'rudi-invitation-list');
        renderInvitationForm(formNode, username, sapidoe, bearerToken, hastTOTPPermission);
        getBackendData("", `/users/invitation/list/${sapidoe}`, "GET", "application/json", bearerToken, function (response) {
            const responseData = JSON.parse(response.target.response);
            DomHelper.appendSpinner(listNode);
            renderInvitationList(listNode, username, sapidoe, bearerToken, responseData);
        });
    }
}
function validateInvitationInput(valuetype, inputNode, username, sapidoe, bearerToken) {
    const value = inputNode.value;
    if ((valuetype != 'mobile' && valuetype != 'mail' && valuetype != 'totp'))
        throw 'Einladungstyp muss ausgewählt werden';
    if (!value)
        throw 'Bitte geben Sie einen Wert ein';
    let data = {
        createdby: username,
        sapidoe: sapidoe,
        phone: "",
        mail: "",
        username: ""
    };
    if (valuetype == 'totp') {
        const pattern = /^[a-z]+\d?\d?$/;
        if (!pattern.test(value))
            throw "Bei TOTP darf nur ein Nutzername in Kleinbuchstaben eingegeben werden. ";
        data.username = value;
        data["tokenid"] = "create";
    }
    else if (valuetype == 'mobile') {
        const pattern = /^\+[0-9]+$/;
        if (!pattern.test(value))
            throw "Die Telefonnummer muss im Format +491123604... ohne Leerzeichen und Trennzeichen eingeben werden";
        data.phone = value;
    }
    else if (valuetype == 'mail') {
        if (value.includes('rummelsberger'))
            throw "Alle Rummelsberger Mitarbeitenden haben bereits einen Account. Eine Einladung an Adressen der Rummelsberger Diakonie ist nicht möglich";
        data.mail = value.toLowerCase();
    }
    inputNode.classList.remove('rudi-status-warning');
    const errorMessageNode = document.getElementById('rudi-invitation-error-message');
    if (errorMessageNode) {
        errorMessageNode.innerHTML = "";
        errorMessageNode.classList.add('disabled');
    }
    return data;
}
function renderInvitationForm(parentNode, username, sapidoe, bearerToken, hastTOTPPermission) {
    DomHelper.appendNode(parentNode, 'h3', [], [], 'Neue Einladung versenden');
    DomHelper.appendNode(parentNode, 'p', [], [], 'Bitte geben Sie entweder eine E-Mail-Adresse oder eine Mobilfunknummer ein. Durch den Button einladen wird dann sofort der Einladungstext verschickt.');
    const errorNode = DomHelper.appendNode(parentNode, 'div', ['disabled', 'warn'], [], '', 'rudi-invitation-form-hint');
    const formSection = DomHelper.appendNode(parentNode, 'section', ['rudi-form-input-group', 'rudi-form-inline'], []);
    const selectNode = DomHelper.appendNode(formSection, "select", ['rudi-inline-icon', 'form-select'], [
        { attr: "id", value: 'rudi-invitation-form-type' },
        { attr: "name", value: 'type' },
        { attr: "type", value: 'text' },
    ]);
    const values = [
        { label: "Mobil", value: "mobile" },
        { label: "E-Mail", value: "mail" }
    ];
    if (hastTOTPPermission) {
        values.push({ label: "TOTP", value: "totp" });
    }
    const valueSelected = 'mobile';
    if (values.length <= 1)
        selectNode.disabled = true;
    for (const option of values) {
        const optionNode = DomHelper.appendNode(selectNode, "option", ['form-select'], [{ attr: "value", value: option.value }], option.label);
        optionNode.selected = valueSelected == option.value;
    }
    const inputNode = DomHelper.appendInputText(parentNode, 'rudi-invitation-form', ['rudi-inline-icon'], [], 'username', '', '', [], false, formSection, true);
    const btnNode = DomHelper.appendNodeAsSibling(inputNode, 'button', ['btn', 'btn-primary'], []);
    DomHelper.appendNode(btnNode, 'i', ['fa-light', 'fa-paper-plane'], []);
    btnNode.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (DEBUG)
            console.log('invitation clicked');
        let usernameIMP = inputNode.value;
        try {
            let data = validateInvitationInput(selectNode.value, inputNode, username, sapidoe, bearerToken);
            getBackendData("", `/public/exists?type=${selectNode.value}&value=${Util.urlEncode(inputNode.value)}`, "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                console.log("exists?", responseData);
                if (!responseData.exists) {
                    if (selectNode.value == 'mobile') {
                        data.phone = inputNode.value;
                    }
                    else {
                        data.mail = inputNode.value;
                    }
                    let sucessMessage = `Die Einladung wurde erfolgreich versandt.`;
                    if (selectNode.value == "totp")
                        sucessMessage = `Der Einladungslink wurde erzeugt. Bitte kopieren Sie diesen und schicken Sie an den User.`;
                    sendBackendData("", `/users/invitation`, "POST", "application/json", bearerToken, data, function (response) {
                        const responseData = JSON.parse(response.target.response);
                        DomHelper.showMessage({
                            appcn: "",
                            appdn: "",
                            duration: 5000,
                            header: "Info",
                            icon: "fa-envelope-circle-check",
                            message: sucessMessage,
                            type: 'info',
                            version: ""
                        }, null, bearerToken);
                        inputNode.value = "";
                        insertInvatiationInList(parentNode, username, bearerToken, responseData);
                        console.log("createdInvitation?", responseData);
                    });
                }
                else {
                    errorNode.innerHTML = "Diese Einladung existiert bereits";
                    errorNode.classList.remove('disabled');
                }
            });
        }
        catch (e) {
            const errorMessageNode = document.getElementById('rudi-invitation-error-message');
            if (errorMessageNode) {
                errorMessageNode.innerHTML = e.toString();
                errorMessageNode.classList.remove('disabled');
            }
            if (inputNode) {
                inputNode.classList.add('rudi-status-warning');
            }
            console.log(e);
        }
    });
}
function insertInvatiationInList(parentNode, username, bearerToken, invitation) {
    const invitationNodes = document.getElementsByClassName('rudi-invitation-item');
    if (invitationNodes) {
        const invitationNode = invitationNodes.item(0);
        if (invitationNode) {
            const newNode = DomHelper.appendNodeBefore(invitationNode, 'div', ['rudi-invitation-item', 'new'], [], '', '');
            const domIdUsername = Util.generateRandomDomId();
            DomHelper.appendNode(newNode, 'p', [], [], '', domIdUsername);
            Util.userId2DisplayName(store, invitation.createdby, domIdUsername, username, bearerToken);
            createMailNode(newNode, invitation);
            DomHelper.appendNode(newNode, 'p', [], [], invitation.phone, '');
            DomHelper.appendNode(newNode, 'p', [], [], Util.isoString2DateString(invitation.von), '');
            DomHelper.appendNode(newNode, 'p', [], [], invitation.completed ? 'Eingeladen' : 'Ausstehend', '');
        }
    }
}
function createMailNode(invitationNode, invitation) {
    const mailNode = DomHelper.appendNode(invitationNode, 'p', [], [], '', '');
    const linkNode = DomHelper.appendNode(mailNode, 'a', [], [{
            attr: "href",
            value: `${window.location.origin}/public?action=register&id=${invitation.id}`
        }], "", '');
    DomHelper.appendNode(linkNode, 'i', ['fa-light', 'fa-link', 'themed-color'], []);
    DomHelper.appendNode(mailNode, 'span', [], [], invitation.mail, '');
}
function renderInvitationList(parentNode, username, sapidoe, bearerToken, data) {
    DomHelper.removeSpinner(parentNode);
    DomHelper.appendNode(parentNode, 'h3', [], [], 'Liste der Einladungen');
    if (data.length > 0) {
        const invitationHeaderRow = DomHelper.appendNode(parentNode, 'div', ['rudi-invitation-header'], [], '', '');
        DomHelper.appendNode(invitationHeaderRow, 'p', [], [], 'Eingeladen durch', '');
        DomHelper.appendNode(invitationHeaderRow, 'p', [], [], 'Mailadresse | Username', '');
        DomHelper.appendNode(invitationHeaderRow, 'p', [], [], 'Telefonnummer', '');
        DomHelper.appendNode(invitationHeaderRow, 'p', [], [], 'Eingeladen am', '');
        DomHelper.appendNode(invitationHeaderRow, 'p', [], [], 'Status', '');
    }
    data.forEach(invitation => {
        const invitationNode = DomHelper.appendNode(parentNode, 'div', ['rudi-invitation-item'], [], '', '');
        const domIdUsername = Util.generateRandomDomId();
        DomHelper.appendNode(invitationNode, 'p', [], [], '', domIdUsername);
        Util.userId2DisplayName(store, invitation.createdby, domIdUsername, username, bearerToken);
        createMailNode(invitationNode, invitation);
        DomHelper.appendNode(invitationNode, 'p', [], [], invitation.phone, '');
        DomHelper.appendNode(invitationNode, 'p', [], [], Util.isoString2DateString(invitation.von), '');
        DomHelper.appendNode(invitationNode, 'p', [], [], invitation.completed ? 'Eingeladen' : 'Ausstehend', '');
    });
}
